export const MEDIA_CONSTS = {
  moduleName: 'epb-media',

  getters: {
    device: 'device',
  },
  actions: {
    setViewportWidth: 'setViewportWidth',
  },
  mutations: {
    setViewportWidth: 'setViewportWidth',
  },
}
